import type { Plugin } from 'vue';
import { createGtm } from '@gtm-support/vue-gtm';
import router from '@/router/index.ts';

const gtmId = process.env.VUE_APP_GTM_ID;

const gtmPlugin: Plugin | null = gtmId
    ? createGtm({
          id: gtmId,
          enabled: true,
          defer: true,
          vueRouter: router,
          trackOnNextTick: false,
      })
    : null;

export default gtmPlugin;
